<template>
	<transition name="fade">
		<div class="system-error" v-if="hasError">
			<span class="close" @click="setError(false)">X</span>
			<span>
				Hiba lépett fel a rendszerben, kérjük keresse ügyfélszolgálatunkat. <br>
				Ügyfélszolgálatunk telefonszáma: 06 1 585 8888, email címe: info@eurorisk.hu
			</span>
		</div>
	</transition>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
	computed: {
		...mapGetters(['hasError']),
	},
	methods: {
		...mapMutations(['setError']),
	},
};
</script>

<style scoped lang="scss">
.system-error {
	position: fixed;
	right: 10px;
	top: 10px;
	background: indianred;
	padding: 15px;
	border-radius: 8px;
	color: white;
	box-shadow: 0px 2px 6px rgb(0 0 0 / 30%);
	z-index: 99;
	text-align: center;

	.close {
		position: absolute;
		top: 10px;
		right: 10px;
		cursor: pointer;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>
